import { push } from 'redux-little-router';
import logout from "~/backend/logout";
import createPromiseThunk from './lib/createPromiseThunk';
import {defaultPromiseState, setConfig} from "~/config";

const { types, reduce, execute } = createPromiseThunk({
   func: async ({getConfig, dispatch}) => {
       let logoutResult = await logout(getConfig().baseUrl);

       // redirect to home
       if(logoutResult.success) {
           dispatch(push('', {noConfirm: true}));
       }
   },
   name: 'logout'
});

const reduceLogoutState = (state, action) => {
   switch(action.type) {
       case types.SUCCESS:
           setConfig(null);
           return {
               ...state,
               credentials: {username: '', password: ''},
               authResult: {...defaultPromiseState, value: null},
               availableModels: [],
               models: {},
               ui: {
                   ...state.ui,
                   loadedModels: {},
                   currentModelId: null,
                   settings: {},
               }
           };
   }

   return state;
};


export { types as LOGOUT_TYPES, reduce as reduceLogout, execute as logout, reduceLogoutState };